import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Loader2, Building2 } from 'lucide-react';
import { Clinic } from '@/models/clinic.model';
import { Button } from '../ui/button';

interface SwitchClinicDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clinic: Clinic | null;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
}

const SwitchClinicDialog: React.FC<SwitchClinicDialogProps> = ({
  open,
  onOpenChange,
  clinic,
  onConfirm,
  isLoading = false,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
  };

  const handleClose = () => {
    if (!isLoading) {
      onOpenChange(false);
    }
  };

  if (!clinic) return null;

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader>
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-brand-teal/10">
              <Building2 className="h-6 w-6 text-brand-teal" />
            </div>
            <div className="flex-1">
              <DialogTitle className="text-[1.05rem] font-semibold">
                Switch Clinic
              </DialogTitle>
              <DialogDescription className="text-[0.8rem] text-slate-500 mt-0">
                Are you sure you want to switch clinic?
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="py-2">
          <p className="text-sm text-slate-600">
            Are you sure you want to switch to <span className="font-semibold text-slate-900">{clinic.name}</span>? Your current session context will change.
          </p>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-brand-teal hover:bg-brand-teal/90"
          >
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Switching...
              </>
            ) : (
              <>
                <Building2 className="h-4 w-4 mr-2" />
                Switch Clinic
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SwitchClinicDialog;

